import * as React from 'react';
import { useLocalizedSanityNewsBondsByUrlIdWithoutInvalid } from '../../../../../../../../../../../../../../../../sanity';
import { useOuiStyleMediaContextByIndex } from '../../../../../../../../../../../../../../../MediaContext';
import {
  NewsBondPager,
  NewsBondsMapperContainer,
} from './components';
import { NewsBondsMapperWrapper } from './components/wrapper/component';
import { NewsBondCurrenPageProvider } from './context';
import { NewsBondsMapperContent } from './components/content';

export const NewsBondsMapper = () => {
  const {
    data,
  } = useLocalizedSanityNewsBondsByUrlIdWithoutInvalid();
  const isUp = useOuiStyleMediaContextByIndex(3);
  if (data == null) {
    return null;
  }
  return (
    <NewsBondsMapperWrapper>
      <NewsBondCurrenPageProvider>
        <NewsBondsMapperContainer>
          <NewsBondsMapperContent />
        </NewsBondsMapperContainer>
        {!isUp && data.length > 1 ? <NewsBondPager /> : null}
      </NewsBondCurrenPageProvider>
    </NewsBondsMapperWrapper>
  );
};
